import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './ConnectedIntegration.module.scss'
import { useConnectedAccountCardProps } from 'components/IntegrationsModal/ManageIntegrationAccounts/hooks'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
interface Props {
  integration: ExternalIntegration
  showDisconnectButton?: boolean
}

export const ConnectedIntegration = ({ integration, showDisconnectButton = true }: Props) => {
  const { name, avatarUrl, onDisconnectAccount } = useConnectedAccountCardProps(integration)

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.integration}>
        <img src={avatarUrl || Silhouette} alt={name} className={Styles.avatar} />
        <Text variant="smallList" lineClamp={1}>
          {name}
        </Text>
      </div>
      {showDisconnectButton && (
        <Button onPress={onDisconnectAccount} variant="tertiary" size="sm">
          Disconnect
        </Button>
      )}
    </div>
  )
}
